import styled, { css } from 'styled-components';

import { Flex, Container, Text, Button } from '@olxbr/ds-web';

const loadingStyle = css`
  opacity: 0.7;
  pointer-events: none;
`;

export const Wrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;

  ${({ loading }) => (loading === 'true' ? loadingStyle : '')};

  @media (min-width: 1030px) {
    flex-direction: row;
  }
`;

const bg = css`
  border: var(--border-width-hairline) solid var(--color-secondary-medium);
  
  @media (min-width: 1030px) {
    margin: 0 var(--spacing-stack-xxs);
    margin-bottom: var(--spacing-stack-xxs);
  }
`;

export const Card = styled(Container)`
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: var(--spacing-stack-xxs);
  padding: var(--spacing-stack-xxxs);
  min-width: 280px;
  max-width: 600px;
  flex-direction: column;
  align-items: center;

  ${({ isTopSeller }) => (isTopSeller ? bg : '')};

  @media (min-width: 1030px) {
    width: 100%;
    min-height: 897px;
  }
  `;

export const TopSeller = styled(Text.BodySmall)`
  border: var(--border-width-hairline) solid var(--color-neutral-dark);
  border-radius: var(--border-radius-pill);
  padding: 2px var(--spacing-stack-nano);
  background-color: var(--color-neutral-lightest);
  color: var(--color-secondary-medium);
  margin-top: -30px;
  position: absolute;
`;

export const InfoListItem = styled.div`
  display: flex;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 132%;
  margin-bottom: var(--spacing-stack-nano);
`;

export const CheckContainer = styled(Flex)`
  min-width: 38px;
`;

export const CheckItem = styled(Text.BodySmall)`
  strong {
    font-weight: bold;
  }

  color: ${({ disabled }) => (disabled ? 'var(--color-neutral-darker)' : 'var(--color-neutral-darkerst)')};
`;

export const BuyButton = styled(Button)`
  margin: var(--spacing-stack-xxxs) 0;
`;
